export function getBadgeClass(estado) {
  switch (estado?.toLowerCase()) {
    case "en-curso":
      return "badge bg-soft-primary text-white fs-11";

    case "finalizada":
      return "badge bg-soft-black text-white fs-11";

    case "reprogramada":
      return "badge bg-soft-red text-white fs-11";

    case "suspendida":
      return "badge bg-soft-grey-74 text-white fs-11 ";
    
    case "confirmada":
      return "badge bg-soft-black text-white fs-11 ";
  }
}

export function getBadgeText(estado) {
  switch (estado?.toLowerCase()) {
    case "confirmada":
      return "PRÓXIMAMENTE";

    default:
      return estado;
  }
}